import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loaded: false,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    start(state) {
      return { ...state, loaded: true, startTimestamp: Date.now() };
    },
    set(_, action) {
      return action.payload;
    },
    update(state, action) {
      return { ...state, ...action.payload };
    },
  },
});

export const app = appSlice.actions;
export default appSlice.reducer;
